import React from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { adminAPI } from '../../../api';

import useModal from '../../../context/ModalContext';
import useAlarm from '../../../context/AlarmContext';
import FormLoader from '../../../components/FormLoader';

const DestroyModal = ({ items, type, queryListId, setItems, checkedAllUsers, totalUsers, filter, searchQuery, handleSelectAllUsers }) => {
  const { setAlarm } = useAlarm();
  const { setContent, closeModal } = useModal();

  const bulkEmailLimit = parseInt(window.ENV?.BULK_EMAIL_LENGTH || process.env.REACT_APP_BULK_EMAIL_LENGTH || '1', 10);

  const queryClient = useQueryClient();

  const { mutate, isLoading: mutationIsLoading } = useMutation(
    (input) =>
      adminAPI.destroyInvitationOrUsers(input.serializedData, input.type),
    {
      onSuccess: (data) => {
        setAlarm({ type: 'success', message: data.message });
        setContent({ title: null, body: null });
        setItems([]);
        handleSelectAllUsers(false);
        queryClient.invalidateQueries('allUsers');
        closeModal();
      },
      onSettled: (_data, error) => {
        if (error) {
          setAlarm({ type: 'error', message: error.message });
          queryClient.invalidateQueries('allUsers');
          closeModal();
        }
      },
    }
  );

  const handleSubmit = (event) => {
    event.preventDefault();

    let dataToSend;

    if (checkedAllUsers === true && totalUsers > bulkEmailLimit) {
      // For bulk operations, merge updateData with items
      dataToSend = {
        filter: filter,
        searchQuery: searchQuery,
        queryListId: queryListId,
      };
    } else {
      // For individual items, send items directly
      dataToSend = items;
    }

    const serializedData = JSON.stringify(dataToSend);
    mutate({ serializedData, type });
  };

  const typeText = type === 'users' ? 'User' : 'Invitation';
  const appendS = checkedAllUsers && totalUsers > 1 ? 's' : '';
  const finalText = typeText + appendS;
  return (
    <>
      <form onSubmit={handleSubmit}>
        <h2 className="font-semibold">Delete {finalText}</h2>
        {checkedAllUsers ? (
          <p className="mb-8">Are you sure want to delete all {totalUsers.toLocaleString('en-US')} {finalText.toLowerCase()}?</p>
        ) : (
          <>
        <p>
          Are you sure you want to delete the following{' '}
          {finalText.toLowerCase()}?
        </p>
        <div
          style={{ maxHeight: '400px' }}
          className="border-2 border-gray rounded-2lg p-4 overflow-y-scroll my-8"
        >
          {items.map((item) => (
            <p key={item.email}>{item.email}</p>
          ))}
        </div>
          </>
        )}

        <button
          type="submit"
          className="font-semibold p-4 rounded-lg bg-red text-white"
        >
          Delete {items.count} {finalText}
        </button>
      </form>
      {mutationIsLoading && <FormLoader />}
    </>
  );
};

export default DestroyModal;
